export default function JoinCta() {
  return (
    <section id="subscribe" className="relative scroll-mt-20 overflow-hidden bg-primary-600">
      <div className="pointer-events-none absolute -right-10 -top-16 font-display text-[16rem] font-black leading-none text-white/5 select-none md:text-[24rem]">
        瓜
      </div>
      <div className="pointer-events-none absolute -bottom-24 -left-10 font-display text-[16rem] font-black leading-none text-foreground-950/10 select-none">
        全
      </div>
      <div className="relative mx-auto flex max-w-7xl flex-col items-center gap-5 px-4 py-14 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
          <span className="flex h-2 w-2 items-center justify-center">
            <i className="ri-mail-send-line text-accent-300" />
          </span>
          每期封面准时送到
        </span>
        <h2 className="max-w-2xl font-heading text-3xl font-black leading-snug text-background-50 md:text-5xl">
          别让好瓜错过你，
          <br className="hidden md:block" />
          把「嘿料吃瓜」装进订阅栏
        </h2>
        <p className="max-w-xl text-sm leading-relaxed text-white/80 md:text-base">
          本周最新档案、年度合集上新与专栏导读，一封邮件讲清楚。本期为静态示例页面，订阅入口暂不接入真实推送。
        </p>
        <form className="mt-2 flex w-full max-w-md flex-col gap-3 sm:flex-row">
          <input
            type="email"
            name="email"
            autoComplete="off"
            placeholder="输入你的邮箱，坐等下一刊"
            className="h-12 flex-1 rounded-md border border-white/25 bg-background-50/95 px-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
          />
          <button
            type="button"
            className="inline-flex h-12 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            订阅开瓜
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-send-plane-line" />
            </span>
          </button>
        </form>
        <p className="text-xs text-white/60">点按按钮仅作演示，不会收集任何信息。</p>
      </div>
    </section>
  );
}